var _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgMenuTransactions = function SvgMenuTransactions(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    enableBackground: "new 0 0 40 40",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "MT_1_",
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "MT_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MT_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MT_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M29.502,17.258V33.51c0,1.096-0.889,1.984-1.984,1.984H7.454c-1.096,0-1.984-0.889-1.984-1.984V8.508 c0-1.096,0.888-1.985,1.984-1.985h17.048"
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#MT_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 9.576,
    y1: 28.508,
    x2: 25.396,
    y2: 28.508
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#MT_2_)",
    fill: "none",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 9.576,
    y1: 23.5,
    x2: 13.121,
    y2: 23.5
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MT_2_)",
    fill: "#00C752",
    d: "M35.605,6.229c0.765-0.763,0.765-2.065,0-2.828 c-0.763-0.765-2.066-0.765-2.829,0l-6.363,6.364l2.828,2.828l5.586-5.586c0.096,0.203,0.156,0.416,0.157,0.637 c-0.001,0.385-0.146,0.766-0.439,1.061l-4.949,4.949c-0.196,0.195-0.196,0.512,0,0.707c0.194,0.195,0.512,0.195,0.707,0 l4.949-4.949c0.487-0.488,0.732-1.13,0.732-1.768c0-0.48-0.139-0.962-0.415-1.379L35.605,6.229z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#MT_2_)",
    fill: "#00C752",
    d: "M25.706,10.473l-9.165,9.157c-1.414,1.414-1.767,3.889-1.414,4.242 c0.354,0.354,2.829,0,4.244-1.413l9.163-9.158L25.706,10.473z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuTransactions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-transactions.9d458b20.svg";
export { ForwardRef as ReactComponent };